module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', {
    attrs: {
      "color": "true"
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("\n        Valmistuneet projektit\n      ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "bloc bgc-white l-bloc"
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-vuetable-container', [_c('vuetable', {
    ref: "vuetable",
    staticClass: "mg-md",
    attrs: {
      "css": _vm.css,
      "api-url": _vm.url + '/projects?organizationId=' + _vm.$store.state.account.organizationId,
      "fields": _vm.fields,
      "query-params": {
        sort: '$sort',
        page: '',
        perPage: '$limit'
      },
      "no-data-template": _vm.noDataTemplate(this.loading, 'Ei vielä lisättyjä projekteja.')
    },
    on: {
      "vuetable:loaded": _vm.onLoading
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('router-link', {
          staticClass: "btn btn-sm inverse-color pull-right",
          attrs: {
            "to": {
              name: 'bids-open.index',
              params: {
                projectId: props.rowData.id,
                projectName: props.rowData.projectName
              }
            }
          }
        }, [_c('span', {
          staticClass: "ion ion-eye icon-spacer icon-midnight-blue"
        }), _vm._v("Näytä projekti\n                  ")])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.loading) ? _c('v-spinner') : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('vk-modal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "clickOut": function($event) {
        _vm.show = false
      },
      "inactive": function($event) {
        _vm.show = false
      },
      "keyEsc": function($event) {
        _vm.show = false
      }
    }
  }, [_c('a', {
    staticClass: "uk-close",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', [_vm._v("Uusi projekti")])]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "name": "projectName",
      "source": "project",
      "rules": "required"
    }
  }, [_vm._v("\n      Nimi\n    ")]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "name": "projectNumber",
      "source": "project",
      "rules": "required"
    }
  }, [_vm._v("\n      Projekti NRO\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-d",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("Peruuta")]), _vm._v(" "), _c('a', {
    staticClass: "btn pull-right btn-lime-green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateProject($event)
      }
    }
  }, [_vm._v("Tallenna")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-786832b9"}!./src/app/pages/project-history/project-history.html
// module id = 491
// module chunks = 1